import './components/mobile-menu'; //use
import './components/modals'; //use
import './components/sliders'; //use
import './components/dinamicHeight'; //use
import './components/form-validate';
import './components/anchor'; //use
import './components/tooltip'; //use
import './components/fileUpload'; //use

import './components/infiniteArticles'; //use
import './components/infiniteBooks'; //use
import './components/infiniteTags'; //use
import './components/infiniteBlogs'; //use

import './components/search'; //use
// import './components/infiniteSearch'; //use